import get from 'lodash/get'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ArticleWidget } from 'shared/components'
import { HelmetWidget } from 'user/components'
import './style.css'

export default class Article extends Component {
  static propTypes = {
    article: PropTypes.any,
    companyName: PropTypes.string,
    getArticle: PropTypes.func.isRequired
  }

  componentDidMount () {
    this.props.getArticle(this.props.match.params.widgetId)
  }

  render () {
    return (
      <div className='container app-content-container'>
        <HelmetWidget
          companyName={this.props.companyName}
          pageTitle={get(this.props.article, 'page_title')}
          pageDescription={get(this.props.article, 'page_description')}
          widgetName={get(this.props.article, 'name')}
          widgetType='article'
        />
        <ArticleWidget
          article={this.props.article} />
      </div>
    )
  }
}
